import React from 'react';
import styled from 'styled-components';
import Svg from '_assets/svg';
import H4 from 'components/H4';
import Button from 'components/Button';

const Img = styled.img`
    width: 20px;
    height: 20px;
`

const Divider = styled.div`
    height: 24px;
    width: 1px;
    background: #C4C4C4;
    margin-inline: 13px;
`

const Wrapper = styled.div`
    @media only screen and (max-width: 1024px) {
        margin-top: 10px;
    }
`
const ViewAs = () => {
    return (
        <Wrapper className="d-flex flex-row align-items-center">
            <H4>View as:</H4>
            <Button className="margin-left-10" typeViewAs>
                <Img src={Svg.view_list.default} />
                <Divider />
                <Img src={Svg.view_column.default} />
            </Button>
        </Wrapper>
    )
}

export default ViewAs;